import React from 'react';
import { Accordion } from '@noths/polaris-client-ribbons-design-system';

import type { DeliveryFAQs as DeliveryFAQsContent } from 'src/redux/content/types';
import * as styles from './DeliveryFAQs.styles';

export type DeliveryFAQsProps = DeliveryFAQsContent;

const ACCORDION_ID_PREFIX = 'delivery-faq';

const getAccordionId = (question: string) => {
  return `${ACCORDION_ID_PREFIX}-${question.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
};

export const DeliveryFAQs = ({ heading, items }: DeliveryFAQsProps) => {
  return (
    <section aria-label={heading} css={styles.root}>
      <h2>{heading}</h2>
      <ul css={styles.questions}>
        {items.map((item) => (
          <li key={item.question}>
            <Accordion
              id={getAccordionId(item.question)}
              open={false}
              title={<h3>{item.question}</h3>}
            >
              <div css={styles.answer} dangerouslySetInnerHTML={{ __html: item.answer }} />
            </Accordion>
          </li>
        ))}
      </ul>
    </section>
  );
};
